import { MEDIA_PATH } from '../constants';

interface FormatNode {
  node: {
    id: string;
    fmtType: {
      slug: string;
    };
    online?: boolean;
  };
}

interface FormatSet {
  edges?: FormatNode[];
}

export const getFormatId = (formats: FormatNode[] | undefined, formatType: string): string | null => {
  if (formats?.length && formats?.length > 0) {
    const fm = formats?.filter((f) => f.node.fmtType.slug === formatType).map((f) => f.node.id);
    if (fm.length > 0) return fm[0];
  }
  return null;
};

export const getFormatSetId = (formatSet: FormatSet | undefined, formatType: string): string | undefined => {
  return formatSet?.edges?.find((f) => f.node.fmtType.slug === formatType)?.node.id;
};

export const getFormat = (
  formatSet: FormatSet | undefined | null,
  formatType: string | undefined | null,
): FormatNode | undefined | null => {
  if (!formatSet || !formatType) return null;
  return formatSet?.edges?.find((f) => f.node.fmtType.slug === formatType);
};

export const generateMediaUrlFromFormat = (formatSet: FormatSet | undefined, formatType: string): string => {
  const format = getFormat(formatSet, formatType);
  return `${MEDIA_PATH}/` + `${format?.node?.id}`;
};

export const getFormatOnlineStatus = (formatSet: FormatSet | undefined, formatType: string): boolean | undefined => {
  const format = getFormat(formatSet, formatType);
  return format?.node?.online;
};
